import { isHmBrand } from "@pb/utils/brandConfig";
const EVENT_TYPES = {
    add_to_favourites: 'ADD_TO_FAVOURITES',
    remove_from_favourites: 'REMOVE_FROM_FAVOURITES',
};
const EVENT_ID = {
    add_to_favourites: 'Add to favourites',
    remove_from_favourites: 'Remove from favourites',
};
const generalTrackingConstants = (isAdd) => {
    return {
        event_type: isAdd ? EVENT_TYPES.add_to_favourites : EVENT_TYPES.remove_from_favourites,
        event_id: isAdd ? EVENT_ID.add_to_favourites : EVENT_ID.remove_from_favourites,
        event_category: 'Favourites',
    };
};
const hmTrackingConstants = {
    product_id: [''],
    product_article_id: [''],
    product_name: [''],
    product_category: [''],
    product_brand: [''],
    product_color_code: [''],
    product_currency: [''],
    product_discount: [''],
    product_list_price: [''],
    product_few_pieces: [''],
    product_original_price: [''],
    product_price_type: [''],
    product_osa_area: [''],
    product_osa_type: [''],
    product_quantity: ['1'],
    product_rating: [''],
    product_rating_avg: [''],
    product_size: [''],
    product_size_code: [''],
    product_size_rec: [''],
    product_ugc: [''],
    product_view_price_type: [''],
    product_view_type: [''],
    selected_market: '',
    display_language: [''],
};
const brandsTrackingConstants = {
    page_id: '',
    page_type: '',
    region_locale: '',
    region_market: '',
    session_login_status: '',
    session_touchpoint: '',
    region_currency: '',
    product_id: [''],
    product_name: [''],
    product_brand: '',
    product_category: [''],
    product_price: [''],
    product_original_price: [''],
    product_color: [''],
    product_color_code: [''],
    product_size: [''],
    product_size_code: [''],
    product_currency: '',
};
const trackingConstants = {
    ADD_TO_FAVOURITES: Object.assign(Object.assign({}, generalTrackingConstants(true)), (!isHmBrand ? brandsTrackingConstants : hmTrackingConstants)),
    REMOVE_FROM_FAVOURITES: Object.assign(Object.assign({}, generalTrackingConstants(false)), (!isHmBrand ? brandsTrackingConstants : hmTrackingConstants)),
};
export default trackingConstants;
//# sourceMappingURL=trackingConstants.js.map